import { algoliasearch } from "algoliasearch"
import { InstantSearch, Configure } from "react-instantsearch-hooks-web"
import { useWorkbenchStore, initialState } from "../../store/store"
import BrowseBetaResultsContainer from "./BrowseBetaResultsContainer"
import BrowseFiltersContainer from "./BrowseFiltersContainer"
import { algoliaRouting } from "../../shared/utils/algoliaRouting"
import { useStateFromAlgoliaParams } from "../../shared/utils/useStateFromAlgoliaParams"
import { useEffect, useState } from "react"
import { resultsFilters } from "../../pages/browse/FilterTransforms"
import ErrorBoundary from "../../shared/components/ErrorBoundary"
import { mapSortToReplica } from "./FilterTransforms"

const searchClient = algoliasearch("QWRONMN15C", "16428b96d5772af99517905d409adbd8")

const BrowseBetaContainer = () => {
  const el = document.getElementById("mm-browse-beta-container")
  const user_role = el && el.getAttribute("data-user-role")
  const indexName = el && el.getAttribute("data-index-name")
  const currentIndexName = indexName

  // Store current index name globally so algoliaRouting can read it (fixes pagination and state restore after login redirect)
  window.__AIS_INDEX_NAME__ = currentIndexName
  const getInitialRestrictedAttributes = () => {  
    const params = new URLSearchParams(window.location.search)
    const filterName = params.get("filter")
    if (!filterName) return []
    const match = resultsFilters.find((item) => item.name === filterName)
    return match ? match.restrictedAttributes : []
  }
  const [restrictedAttributes, setRestrictedAttributes] = useState(getInitialRestrictedAttributes())

  const getInitialUiState = () => {
    const params = new URLSearchParams(window.location.search)
    const pageParam = parseInt(params.get("page"))
    const filterName = params.get("filter")
    const sortKey = params.get("sort")
    const match = resultsFilters.find((item) => item.name === filterName)
    const restrictAttrs = match ? match.restrictedAttributes : undefined
    return {
      [currentIndexName]: {
        page: Number.isNaN(pageParam) ? undefined : pageParam,
        configure: restrictAttrs ? { restrictSearchableAttributes: restrictAttrs } : undefined,
        sortBy: sortKey ? mapSortToReplica(currentIndexName, sortKey) : undefined,
      },
    }
  }
  const selectedResultsFilter = useWorkbenchStore((state) => state.selectedResultsFilter)

  const setStateFromParams = () => {
    const stateFromParams = useStateFromAlgoliaParams()
    const params = new URLSearchParams(window.location.search)
    const sortKey = params.get("sort")
    const replica = sortKey ? mapSortToReplica(window.__AIS_INDEX_NAME__, sortKey) : undefined

    useWorkbenchStore.setState((state) => ({
      ...state,
      ...initialState,
      ...stateFromParams,
      //to preserve sort state 
      sortedIndexName: replica ?? state.sortedIndexName,
    }))
  }

  // Load any given URL params into state on initial page load
  useEffect(() => {
    setStateFromParams()
  }, [])

  // When a user clicks 'Back', reset state to those given by the URL params set by Algolia
  useEffect(() => {
    window.addEventListener("popstate", setStateFromParams)

    return () => {
      window.removeEventListener("popstate", setStateFromParams)
    }
  }, [])

  // Change Algolia configuration when results filter dropdown changes
  useEffect(() => {
    const matchingResultsFilter = resultsFilters.find((item) => item.name === selectedResultsFilter)
    setRestrictedAttributes(matchingResultsFilter.restrictedAttributes)
  }, [selectedResultsFilter])

  return (
    <InstantSearch
      indexName={currentIndexName}   
      searchClient={searchClient}
      routing={algoliaRouting}
      initialUiState={getInitialUiState()}
      stalledSearchDelay={350}
    >
      <Configure
        hitsPerPage={25}
        getRankingInfo={true}
        distinct={10}
        restrictSearchableAttributes={
          restrictedAttributes && restrictedAttributes.length ? restrictedAttributes : undefined
        }
        ruleContexts={[user_role]}
      />

      {/* <WorkbenchContainer user_role={user_role} /> */}
      <ErrorBoundary displayError>
        <BrowseFiltersContainer user_role={user_role}  baseIndexName={currentIndexName} />
      </ErrorBoundary>
      <BrowseBetaResultsContainer user_role={user_role} />
    </InstantSearch>
  )
}

export default BrowseBetaContainer
